/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * Server-projected live state honouring presenceOverride first, then liveState if within display validity threshold, else UNKNOWN. This is what UI code SHOULD render.
 * @export
 */
export const EffectiveLiveState = {
    LIVE: 'LIVE',
    OFFLINE: 'OFFLINE',
    UNKNOWN: 'UNKNOWN'
} as const;
export type EffectiveLiveState = typeof EffectiveLiveState[keyof typeof EffectiveLiveState];


export function instanceOfEffectiveLiveState(value: any): boolean {
    for (const key in EffectiveLiveState) {
        if (Object.prototype.hasOwnProperty.call(EffectiveLiveState, key)) {
            if (EffectiveLiveState[key as keyof typeof EffectiveLiveState] === value) {
                return true;
            }
        }
    }
    return false;
}

export function EffectiveLiveStateFromJSON(json: any): EffectiveLiveState {
    return EffectiveLiveStateFromJSONTyped(json, false);
}

export function EffectiveLiveStateFromJSONTyped(json: any, ignoreDiscriminator: boolean): EffectiveLiveState {
    return json as EffectiveLiveState;
}

export function EffectiveLiveStateToJSON(value?: EffectiveLiveState | null): any {
    return value as any;
}

export function EffectiveLiveStateToJSONTyped(value: any, ignoreDiscriminator: boolean): EffectiveLiveState {
    return value as EffectiveLiveState;
}

